<template>
  <div class="table">
    <div class="table-header">
      <div class="table-row">
        <div class="cell sort cell-xlarge center" @click="setSorting('ref')">
          REF
          <BaseIcon
            v-if="sortingOn == 'ref'"
            :name="this.isAscending ? 'chevron-up' : 'chevron-down'"
            class="icon"
          />
        </div>
        <div class="cell cell-xx-small"></div>
        <div class="cell cell-big">Name</div>
        <div class="cell cell-big">Equipment</div>
        <div class="cell"></div>
        <LoadAmountList
          v-if="hasAmountDropdown"
          :totalItems="totalItems"
          @selectedAmount="selectedAmount"
        />
      </div>
    </div>
    <div class="table-content">
      <div
        class="table-row"
        v-bind:class="{'active-line-padding': selectedStep === step}"
        v-for="(step, index) in this.steps"
        :key="index"
        @click="selectRow(step)"
      >
        <div class="cell cell-xlarge center">{{step.stepID}}</div>
        <div class="cell cell-xx-small"></div>
        <div class="cell cell-big">{{step.name}}</div>
        <div class="cell cell-big">{{step.equipment}}</div>
        <div class="cell" @click="selectRow(step)" @click.stop="openQR(step.stepID)">
          <BaseIcon name="qrcode" class="icon" size="lg" />
        </div>
        <div v-if="isQROpen && openedQR == step.stepID" class="fullscreen">
          <div class="imageview sm" v-if="step.QRParameter === null">
            <button class="btn-close" @click.stop="closeQR">
              <BaseIcon name="window-close" class="icon" />
            </button>
            <qr-code id="qrPrint" class="print" :text="qrString[0]" :size="200" error-level="L" />
            <qr-code
              id="qrPrintsmall"
              class="print hidden"
              :text="qrString[0]"
              :size="70"
              error-level="L"
            />
            <BaseButton size="semi" color="primary" @click.native="print(0)">
              <span class="font-semi">Print QR-code</span>
              <BaseIcon name="print" class="icon white" />
            </BaseButton>
          </div>

          <div class="imageview m" v-if="step.QRParameter !== null">
            <button class="btn-close" @click.stop="closeQR">
              <BaseIcon name="window-close" class="icon" />
            </button>
            <div class="qr-container-print">
              <div class="qr-codes" v-for="(string, index) in qrString" :key="index">
                <div class="qr-code qrPrint">
                  <qr-code class="print" :text="string" :size="200" error-level="L" />
                  <span
                    v-if="step.QRParameter !== null && step.QRParameters[index]"
                  >{{ step.QRParameter }}: {{ step.QRParameters[index].name }}</span>
                </div>
                <div class="qr-btns">
                  <BaseButton
                    size="small qr-btn qr-btn-print"
                    color="primary"
                    @click.native="print(index)"
                  >
                    <BaseIcon name="print" class="icon white" alt="Print above QR-code" />
                  </BaseButton>
                  <BaseButton
                    size="small qr-btn qr-btn-delete"
                    color="delete"
                    @click.native="deleteQR(step.stepID, step.QRParameters[index].name)"
                  >
                    <BaseIcon
                      name="trash-alt"
                      class="icon white"
                      alt="Delete above QR-code parameter"
                    />
                  </BaseButton>
                </div>
              </div>
              <div class="qr-codes">
                <h2>Parameters for {{step.QRParameter}}</h2>
                <DynamicSimplifiedStepsList
                  label="QR Values"
                  name="QR Values"
                  :filledValues="qrparameters"
                  @updateValues="gotQRParameters"
                />
                <BaseButton
                  size="small qr-btn"
                  color="primary"
                  @click.native="addNewQRs(step.stepID)"
                >
                  <span class="font-semi">Add</span>
                  <!-- <BaseIcon name="print" class="icon white" alt="Print above QR-code" /> -->
                </BaseButton>
              </div>
            </div>
          </div>
        </div>
        <div class="cell" @click.stop="openMenu(index)">
          <BaseIcon name="ellipsis-h" class="icon grey" size="lg" />
        </div>
        <MoreTableActions
          v-if="isOptionOpen && openOptions == index"
          :locationMenu="index == 0 ? 'bottom' : 'top'"
          @deleteRow="deleteRow"
          v-click-outside="closeMenu"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import BaseButton from "@/components/base/Button";
import MoreTableActions from "@/components/base/MoreTableActions";
import LoadAmountList from "@/components/base/LoadAmountList";
import DynamicSimplifiedStepsList from "@/components/base/DynamicSimplifiedStepsList";

export default {
  components: {
    BaseIcon,
    BaseButton,
    MoreTableActions,
    LoadAmountList,
    DynamicSimplifiedStepsList
  },
  computed: {},
  props: {
    steps: {
      type: Array,
      required: true
    },
    hasAmountDropdown: {
      type: Boolean,
      default: true
    },
    totalItems: Number
  },
  mounted() {
    this.qrS;
  },
  data() {
    return {
      selectedStep: null,
      sortingOn: "ref",
      isAscending: true,
      isOptionOpen: false,
      openOptions: "",
      isQROpen: false,
      qrString: [],
      openedQR: "",
      openedQRName: "",
      qrparameters: []
    };
  },
  methods: {
    addNewQRs(stepID) {
      console.log(this.selectedStep);
      this.qrparameters.forEach((element, index) => {
        if (element.name == "") {
          this.qrparameters.splice(index, 1);
        } else {
          this.qrparameters[index].stepID = stepID;
          this.qrparameters[index].customValue = this.qrparameters[index].name;
        }
      });
      var that = this;

      that.closeQR();
      this.$http
        .put(this.$endpoint + "management/productionStep/qrparameters/", {
          qrparameters: this.qrparameters,
          name: this.selectedStep.name
        })
        .then(response => {
          that.$emit("refresh", true);
          this.qrparameters = [];
          if (this.steps != []) {
            that.openQR(stepID);
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.$store
              .dispatch("logout")
              .then(() => this.$router.push("/login"))
              .catch(err => console.log(err));
          } else {
            that.$swal(
              "Oops that went wrong?",
              `Please contact the admin with the following info: ${error}`,
              "error"
            );
          }
        });
    },
    deleteQR(stepID, qrparameter) {
      var that = this;
      that.closeQR();
      this.$http
        .delete(
          this.$endpoint +
            "management/productionStep/qrparameters/" +
            stepID +
            "/" +
            qrparameter +
            "/" +
            this.selectedStep.name
        )
        .then(response => {
          // this.isOptionOpen = false
          // this.openOptions = ''
          that.$emit("refresh", true);
          that.openQR(stepID);
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.$store
              .dispatch("logout")
              .then(() => this.$router.push("/login"))
              .catch(err => console.log(err));
          } else {
            that.$swal(
              "Oops that went wrong?",
              `Please contact the admin with the following info: ${error}`,
              "error"
            );
          }
        });
    },
    selectedAmount(val) {
      this.$emit("selectedAmount", val);
    },
    selectRow(step) {
      if (this.selectedStep != step) {
        this.isOptionOpen = false;
      }
      this.selectedStep = step;
      this.$emit("selectedRow", step);
    },
    openMenu(index) {
      if (this.openOptions != index) {
        this.isOptionOpen = true;
      } else {
        this.isOptionOpen = !this.isOptionOpen;
      }
      this.openOptions = index;
    },
    closeMenu() {
      this.isOptionOpen = false;
      this.openOptions = "";
    },
    openQR(id) {
      let selectedIndex = this.steps.findIndex(x => x.stepID == id);
      this.qrString = [];
      if (this.steps[selectedIndex].QRParameter !== null) {
        let params = this.steps[selectedIndex].QRParameters;
        params.forEach((param, index) => {
          this.qrString[index] =
            '{"result": "' +
            this.steps[selectedIndex].stepID +
            '", "name": "' +
            this.steps[selectedIndex].name +
            '", "type": "workstation", "company": "SurgiTec", "QRParam": "' +
            param.name +
            '"}';
        });
      } else {
        this.qrString[0] =
          '{"result": "' +
          this.steps[selectedIndex].stepID +
          '", "name": "' +
          this.steps[selectedIndex].name +
          '", "type": "workstation", "company": "SurgiTec"}';
      }
      this.isQROpen = true;
      this.openedQRName = this.steps[selectedIndex].name;
      this.openedQR = id;
      this.openedQREquipment = this.steps[selectedIndex].equipment;
    },
    closeQR() {
      this.isQROpen = false;
      this.openedQR = "";
    },
    print(qrid) {
      // let qrs = document.getElementsByClassName('qrPrint');
      let qr = document.getElementById("qrPrintsmall").innerHTML;
      // console.log(qr);

      const y = window.top.outerHeight / 2 + window.top.screenY - 480 / 2;
      const x = window.top.outerWidth / 2 + window.top.screenX - 720 / 2;
      const WinPrint = window.open(
        "",
        "",
        `left=${x},top=${y},width=500,height=400,toolbar=0,scrollbars=0,status=0`
      );


      WinPrint.document.write(
        // "<html><head><style>* { font-family: sans-serif; }</style>"
        "<html><head><title>Print QR</title><style>* { font-family: sans-serif; }</style>"
      );
      WinPrint.document.write("</head><body width=400>");
      WinPrint.document.write('<div style ="padding-left:20px">');
      WinPrint.document.write(qr);
      WinPrint.document.write('<p style ="font-size:12px;">');
      // WinPrint.document.write(this.openedQR);
      WinPrint.document.write("name: " + this.openedQRName+ " <br> equ: " + this.openedQREquipment+ " <br> ref: " + this.openedQR);
      WinPrint.document.write("</p>");
      WinPrint.document.write("</div>");
      WinPrint.document.write("</body></html>");

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
    },
    deleteRow() {
      var that = this;
      this.$http
        .get(
          this.$endpoint +
            "management/productionStep/step/delete/" +
            this.selectedStep.stepID
        )
        .then(response => {
          if (response.status == 200) {
            that.$swal("success", `step got deleted`, "success");
            this.isOptionOpen = false;
            this.openOptions = "";
            that.$emit("refresh", true);
          } else if (response.status == 226) {
            let flows = "";
            response.data.forEach(flow => {
              flows += flow.name + "  ";
            });
            that.$swal(
              "revise flows",
              `please revise the flows listed below, they still include your step. ${flows}`,
              "error"
            );
          }
        });
      // .catch(error => {
      //   if (error.response.status === 401) {
      //     this.$store
      //     .dispatch("logout")
      //     .then(() => this.$router.push("/login"))
      //     .catch(err => console.log(err));
      //   } else {
      //     that.$swal(
      //       'Oops that went wrong?',
      //       `Please contact the admin with the following info: ${ error }`,
      //       'error'
      //     );
      //   }
      // })
      // this.$http.delete(this.$endpoint + 'management/productionStep/step/' + this.selectedStep.stepID)
      // .then(response => {
      //   this.isOptionOpen = false
      //   this.openOptions = ''
      //   that.$emit('refresh', true);
      // })
      // .catch(error => {
      //   if (error.response.status === 401) {
      //     this.$store
      //     .dispatch("logout")
      //     .then(() => this.$router.push("/login"))
      //     .catch(err => console.log(err));
      //   } else {
      //     that.$swal(
      //       'Oops that went wrong?',
      //       `Please contact the admin with the following info: ${ error }`,
      //       'error'
      //     );
      //   }
      // })
    },
    setSorting(val) {
      if (this.sortingOn != val) {
        this.isAscending = true;
      } else {
        this.isAscending = !this.isAscending;
      }
      this.sortingOn = val;

      this.$emit("sorting", { on: this.sortingOn, asc: this.isAscending });
    },
    gotQRParameters(newValues) {
      this.qrparameters = newValues;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../style/base.scss";
@import "../style/components/tables.scss";
@import "@/style/components/active.scss";
@import "@/style/components/QRCodes.scss";

.table-header {
  .table-row {
    .cell.sort {
      cursor: pointer;
    }
  }
}

.hidden {
  // visibility: hidden;
  display: none;
}

.fullscreen {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  background-color: rgba($color: #000000, $alpha: 0.16);

  display: flex;
  justify-content: center;
  align-items: center;

  .imageview {
    min-height: 320px;
    min-width: 320px;
    height: 44%;
    width: 22%;
    padding: 24px 40px;
    background-color: white;
    border-radius: 8px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &.m {
      width: auto;
    }

    .print {
      margin-bottom: 16px;
    }

    .btn-close {
      position: absolute;
      top: 24px;
      right: 24px;
      width: 32px;
      height: 32px;

      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;

      background-color: none;
      border: none;

      .icon {
        font-size: 18px;
        color: #d0d0d0;
      }

      &:hover {
        background-color: none;
        cursor: pointer;
        .icon {
          font-size: 18px;
          color: #6a6a6a;
        }
      }
    }
  }
}
</style>
